module.exports = __webpack_public_path__ + "static/media/sf_ui_display_regular.432aa884.ttf";